
import React from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { NotificationPanel } from './NotificationPanel';
import { useNotifications } from '@/hooks/use-notifications';
import { useRequiredActions } from '@/hooks/use-required-actions';

function NotificationBellComponent() {
  const { notifications, unreadCount } = useNotifications();
  const { hasIncompleteActions, requiredActions } = useRequiredActions();

  // Calculate the actual count shown in the panel:
  // - Required actions (if any)
  // - Plus recent unread regular notifications (up to 5, excluding required actions)
  const recentNotifications = notifications.filter(n => !n.is_read && n.type !== 'required_action').slice(0, 5);
  const totalVisibleItems = (hasIncompleteActions ? requiredActions.length : 0) + recentNotifications.length;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="relative p-2 min-w-[48px] h-9 overflow-visible sidebar-notification-badge">
          <Bell className="h-5 w-5" />
          {totalVisibleItems > 0 && (
            <Badge 
              variant={hasIncompleteActions ? "destructive" : "default"}
              className="absolute top-0 right-0 h-4 w-4 p-0 flex items-center justify-center text-xs z-20 text-[10px] shadow-sm"
            >
              {hasIncompleteActions ? '!' : (totalVisibleItems > 99 ? '99+' : totalVisibleItems)}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="end">
        <NotificationPanel />
      </PopoverContent>
    </Popover>
  );
}

// Export memoized component to prevent unnecessary re-renders
export const NotificationBell = React.memo(NotificationBellComponent);
